import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import "../CustomerPortal.css"
import axios from 'axios';
import BackEndUrl from '../../backURL';
import { Col, Row } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Chip } from '@nextui-org/react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, useDisclosure } from "@nextui-org/react";
import { Loader } from '../../components/loaders/Loader';
import EnhacementLetter from '../../components/EnhacementLetter/EnhacementLetter';
import { motion } from 'framer-motion'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCircleXmark, faTimesCircle } from '@fortawesome/free-solid-svg-icons';



const backend = BackEndUrl.domain
function formatDateString(dateString) {
  const date = new Date(dateString);
  const options = {
    year: "numeric",
    month: "short",
    day: "2-digit",

  };
  return date.toLocaleDateString("en-US", options);
}
export const Requests = ({ policy_number, setSelectedService }) => {
  const [requests, setRequests] = useState([]);
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDataRow, setSelectedDataRow] = useState(null)
  const [alteredData, SetAlternateData] = useState();
  const [reqtabledata, setReqTablData] = useState([]);

  useEffect(() => {
    async function GetRequets() {

      try {
        setIsLoading(true)
        const response = await axios.post(backend + "/all-requests", {

          policy_number: policy_number

        }, {
          headers: {
            Authorization: sessionStorage.getItem('token'),
          }
        })
        setRequests(response.data)
        setReqTablData(response.data);
        setIsLoading(false)
      } catch (err) {
        console.log(err)

      }
    }

    if (requests?.length == 0) {
      GetRequets()
    }
  }, []);

  async function alteredDataLoad(req_id) {
    try {
      
      const response = await axios.post(backend + "/alteration_data_load", {
        req_id: req_id,


      }, {
        headers: {
          Authorization: sessionStorage.getItem('token'),
        }
      });
      SetAlternateData(response.data);


    } catch (err) {

    }


  }
  const pdfData = {
    req_id: selectedDataRow?.req_id,
    name: selectedDataRow?.req_full_name,
    address1: selectedDataRow?.address1,
    address2: selectedDataRow?.address2,
    address3: selectedDataRow?.address3,
    address4: selectedDataRow?.address4,
    type_of_req: selectedDataRow?.type_of_req,
    table_name: selectedDataRow?.table_name,
    req_type: selectedDataRow?.req_type,
    old_data: selectedDataRow?.old_data,
    new_data: selectedDataRow?.new_data,
    table_id: selectedDataRow?.table_id


  }

  return (


    <>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange} size={"3xl"} >
              <ModalContent style={{ minHeight: "50dvh" }} className='modal-scroll-bar'  >
                {(onClose) => (
                  <>
                    <ModalHeader className="flex flex-col gap-1" style={{ backgroundColor: "#F7941E", fontSize: "1.7rem", color: "white" }}>Request Details</ModalHeader>
                    <ModalBody     >



                      {selectedDataRow && selectedDataRow.type_of_req == "add_data" ?
                        <>
                          <h1 style={{ fontSize: "1.4rem", textAlign: "center", color: "#13B1F1" }}>Adding New  {selectedDataRow && (
                            selectedDataRow.table_name === "policy_details" ? (
                              <span>Policy</span>
                            ) : (
                              <span>{selectedDataRow.table_name}</span>
                            )
                          )}</h1>
                          <h3 style={{ fontSize: "1.2.5rem", color: "#F7941E" }}>New {selectedDataRow && (
                            selectedDataRow.table_name === "policy_details" ? (
                              <span>Policy</span>
                            ) : (
                              <span>{selectedDataRow.table_name}</span>
                            )
                          )} info    :</h3>

                          <Row className='d-flex justify-content-center my-4'>
                            <Col xs={10} >
                              <Row>

                                <Col xs={6} >
                                  <p className='my-3'><b>Name  :  </b> {selectedDataRow && selectedDataRow.req_full_name} </p>
                                  <p className='my-3'><b>NIC  :   </b> {selectedDataRow && selectedDataRow.req_nic} </p>




                                </Col>
                                <Col xs={6}>

                                  <p className='my-3'><b>Relationship  :   </b> {selectedDataRow && selectedDataRow.req_relationship} </p>
                                  <p className='my-3'><b>Birthday  :    </b> {selectedDataRow && selectedDataRow.req_birthday} </p>
                                  <p className='my-3'><b>Percentage  :    </b> {selectedDataRow && selectedDataRow.percentage} </p>
                                </Col>
                              </Row>
                            </Col>
                          </Row>


                          <div className=' justify-content-center'>

                          </div>

                          <Row>
                            <Col xs={12}>

                            </Col>

                          </Row>

                        </>
                        : null}
                      {selectedDataRow && selectedDataRow.type_of_req == "alteration_data" ?
                        <>
                          <h1 style={{ fontSize: "1.4rem", textAlign: "center", color: "#13B1F1" }}>Altering  {selectedDataRow && (
                            selectedDataRow.table_name === "policy_details" ? (
                              <span>Policy</span>
                            ) : (
                              <span>{selectedDataRow.table_name}</span>
                            )
                          )} Details</h1>
                          <h3 style={{ fontSize: "1.2.5rem", color: "#F7941E" }}>Altering  {selectedDataRow && selectedDataRow.req_type} info    :</h3>

                          <Row className='d-flex justify-content-center my-4'>
                            <Col xs={10} >
                              <Row>
                                {!selectedDataRow.table_name === "policy_details" &&
                                  <Col xs={12}> <p className='my-3'><b>{selectedDataRow && selectedDataRow.table_name}  ID:  </b> {selectedDataRow && selectedDataRow.table_id} </p></Col>

                                }

                                <Col xs={6} >
                                  <p className='my-3'><b>Old  {selectedDataRow && selectedDataRow.req_type} :  </b> {selectedDataRow && selectedDataRow.old_data} </p>





                                </Col>
                                <Col xs={6}>

                                  <p className='my-3'><b>New  {selectedDataRow && selectedDataRow.req_type}  :   </b> {selectedDataRow && selectedDataRow.new_data} </p>
                                </Col>
                              </Row>
                            </Col>
                          </Row>




                          <Row>
                            <Col xs={12}>

                            </Col>

                          </Row>

                        </>
                        : null}

                    </ModalBody>
                    <ModalFooter>


                   {selectedDataRow?.status=="complete"&&selectedDataRow?.type_of_req=="alteration_data" &&selectedDataRow?.req_type!="Policy Full Name"&&<EnhacementLetter
                    data={pdfData}
                    />
                     }
                      <Button color="danger" variant="light" onPress={onClose}>
                        Close
                      </Button>
                    </ModalFooter>
                  </>
                )}
              </ModalContent>
            </Modal>
      <Row className='justify-content-start d-flex' style={{ width: "100%" }}>

        <Col xs={1} className='my-3 justify-content-start d-flex'>
          <motion.div

            onClick={() => {
              setSelectedService(0)

            }}
          >
            <FontAwesomeIcon icon={faArrowLeft} />
          </motion.div>
        </Col>


      </Row>
     
  <Row style={{width:"100%"}}>
    <Col xs={12}>
    <h1 style={{fontSize:"20px", fontWeight:"bold" ,textAlign:"center", marginBottom:"20px"}}>REQUEST LIST</h1>
    {!isLoading && requests.length > 0 ? (
      <DataTable className='p-datatable-table' value={reqtabledata.sort((a, b) => new Date(b.req_created_time) - new Date(a.req_created_time))} paginator rows={10} stripedRows  filterDisplay="row" dataKey="req_id" 
       globalFilterFields={['req_id', 'req_created_time', 'table_name', 'status']} 
      emptyMessage="No customers found." >
      <Column field="req_id" header="Request ID" sortable filter filterPlaceholder="Search by Request Id"/>
      <Column
        field="req_created_time"
        header="Date"
        // body={(rowData) => formatDateString(rowData.req_created_time)}
        body={(rowData) => new Date(rowData.req_created_time).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
        sortable
        filter filterPlaceholder="Search (YYYY-MM-DD)"
      /> 
     
      <Column
        field="table_name"
        header="Change"
        body={(rowData) => rowData.type_of_req === "alteration_data" ? (rowData.table_name === "policy_details" ? "Policy Details Change" : `${rowData.table_name} Change`) : `${rowData.table_name} add`}
        
        filter filterPlaceholder="Search by Change"
      />

      <Column
      
        field="status"
        header="Status"
        body={(rowData) => rowData.status === "pending" ? (
                       <Chip style={{ backgroundColor: "#EDC36F", color: "white", margin: "0", padding: "0" }}>Pending</Chip>
                     ) : rowData.status === "accepted" ? (
                       <Chip style={{ backgroundColor: "#5cb85c", color: "white", margin: "0", padding: "0" }}>Accepted</Chip>
                     ) : rowData.status === "complete" ? (
                       <Chip style={{ backgroundColor: "#2ebc2e", color: "white", margin: "0", padding: "0" }}>Completed</Chip>
                     ) : rowData.status === "reject" ? (
                       <Chip style={{ backgroundColor: "#d9534f", color: "white", margin: "0", padding: "0" }}>Rejected</Chip>
                     ) : null}
        sortable
        filter filterPlaceholder="Search by Status"
      />

    <Column
    style={{padding:"5px"}}
        field="type_of_action"
        header=""
        body={(rowData) => <Button size='sm' onClick={() => { setSelectedDataRow(rowData); onOpen(); }}>Details</Button>}
        sortable
      />
     
    </DataTable>


       ) : (
      <div className='table-container'>
      
       <div style={{minHeight: "50vh", width: "100%" }} className='d-flex justify-content-center align-items-center'>
          {isLoading ? <Loader /> : <div style={{ height: "100%", width: "100%" }} className='d-flex justify-content-center align-items-center'><FontAwesomeIcon icon={ faTimesCircle} style={{scale:"1.5"}}/> <div className='mx-3'>No Requests Found  </div></div>}
        </div></div>
      )}  
    </Col>
  </Row>



      
      </>
  );
}
